import { combineReducers } from "redux";
import common from "../features/admin/common/Slice";


const masters = combineReducers({
    common: common,

});

export default masters;
